import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconDevice, homefieldIconFileCopy, homefieldIconMailEnvelopeOutlined } from '@dsg-tech/homefield-angular-icons';

import { AvailablePointsSummaryComponent } from './available-points-summary.component';
import { CommonModule } from '@angular/common';
import { ErrorStateModule } from '@my-account/components';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { PointsProgressRingComponent } from '@shared/components';

@NgModule({
	declarations: [
		AvailablePointsSummaryComponent
	],
	exports: [
		AvailablePointsSummaryComponent
	],
	imports: [
		CommonModule,
		ErrorStateModule,
		HmfSkeletonComponent,
		HomefieldIconLibraryModule,
		PointsProgressRingComponent
	]
})
export class AvailablePointsSummaryModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconFileCopy, homefieldIconDevice, homefieldIconMailEnvelopeOutlined]);
	}
}
